import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request as fetching the very resource the current URL names, so a 404 on it means the URL
 * is a dead end and `errorInterceptor` renders the not-found page over it.
 *
 * Opt-in on purpose, because the majority is the other case: lesson badges, a class roster, a signed
 * link behind a button. A 404 on those means the *action* failed while the page stayed valid, and
 * navigating away would replace the caller's own error handling with a wrong screen. An endpoint
 * added later is therefore harmless by default.
 *
 * The reads that carry it are the ones that answer "does this URL exist?" — the série home, the
 * lesson tree, the teacher's curriculum. Each is pinned by a test in its own service spec: dropping
 * the mark has to fail loudly, or the 404 page would go quietly unreachable again.
 */
export const NOT_FOUND_IS_DEAD_END = new HttpContextToken(() => false);

/** Context for the reads above — pass as `{ context: notFoundIsDeadEnd() }`. */
export function notFoundIsDeadEnd(): HttpContext {
  return new HttpContext().set(NOT_FOUND_IS_DEAD_END, true);
}
